import { Component, OnInit } from '@angular/core';
import { BookstoreService } from 'src/app/services/bookstore/bookstore.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-issue-package',
  templateUrl: './issue-package.component.html',
  styleUrls: ['./issue-package.component.css']
})
export class IssuePackageComponent implements OnInit {

  AddedItemList: any = [];
  SectionList: any = [];
  BankList: any = [];
  ClassList: any = [];
  PaymentModeList: any = [];
  ItemMasterList: any = [];
  ItemCategoryList = [];
  PackageList: any = [];
  StudentList: any = [];
  FeeReceiptList: any = [];
  OneTimePackageList: any = [];
  GeneralItemList: any = [];
  ItemMsg: any = '';
  ItemQty: any = '';
  ItemList: any = [];
  StudentMsg: any = '';
  PayMsg: any = '';
  PayMsgU: any = '';
  HidePayPack: boolean = false;
  HidePay: boolean = false;
  Submitted: boolean = false;
  AlertSave: "";
  GeneralItemMsg: any;
  FeeReceiptItemList: any = [];


  constructor(private bookstoreservice: BookstoreService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  IssueOneTimePackageModel = {
    ClassID: 0,
    Pay: '0',
    SectionID: 0,
    StudentID: 0,
    ItemID: 0,
    ItemName: '',
    PaymentModeID: 0,
    Qty: 1,
    BankID: 0,
    AvailableQty: 0,
    UnitPrice: 0,
    Remarks: '',
    TotalAmt: 0,
    PaidAmt: 0,
    PackageID: 0,
    IsOneTimePackage: false,
    InventoryCategoryID: 0,
    PaymentStatus: '',
    ChequeNo: '',
    ChequeDate: '',
  }
  ReceiptModel = {
    ReceiptNo: '',
  }

  PackageReceiptModel = {
    ReceiptNo: '',
  }

  GeneralItemModel = {
    ItemCategoryID: 0,
    ClassID: 0,
    ItemID: 0,
    ItemName: '',
    Qty: 1,
    UnitPrice: 0,
    Remarks: '',
    AvailableQty: 0,
    PackageID: 0,
    Pay: '',
    PaidAmt: 0,
    BankID: 0,
    ChequeNo: '',
    ChequeDate: '',
    PaymentModeID: 0,
    PaymentStatus: '',
    StudentID: 0,
    SectionID: 0,

  }

  GeneralItemReceiptModel = {
    ReceiptNo: ''
  }
  IssueOneTimePackageDetails() {
    this.spinnerService.show();
    this.bookstoreservice.IssueOneTimePackageDetails(this.IssueOneTimePackageModel.StudentID).subscribe((data: any) => {
      this.spinnerService.hide();
      this.FeeReceiptList = data.FeeReceiptList;

    });
  };

  GetAvailableQty() {

    this.IssueOneTimePackageModel.UnitPrice = 0;
    this.IssueOneTimePackageModel.AvailableQty = 0;

    for (var i = 0; i < this.ItemMasterList.length; i++) {
      if (this.ItemMasterList[i].ItemId == this.IssueOneTimePackageModel.ItemID) {
        this.IssueOneTimePackageModel.AvailableQty = this.ItemMasterList[i].AvailableQty;
        this.IssueOneTimePackageModel.UnitPrice = this.globalHelper.Decimal(this.ItemMasterList[i].UnitPrice);
        this.IssueOneTimePackageModel.ItemName = this.ItemMasterList[i].ItemName;
        this.IssueOneTimePackageModel.InventoryCategoryID = this.ItemMasterList[i].InventoryCategoryID
      }
    }
  }

  GetAllIssueOneTimePackage() {
    var List = {
      ClassID: this.IssueOneTimePackageModel.ClassID,
      PackageID: this.IssueOneTimePackageModel.PackageID,
    };
    this.bookstoreservice.GetAllIssueOneTimePackage(JSON.stringify(List)).subscribe((data: any) => {
      this.OneTimePackageList = data.OneTimePackageList;


    });
  };

  SetItemList() {
    this.IssueOneTimePackageModel.PaidAmt = 0;
    for (var i = 0; i < this.OneTimePackageList.length; i++) {
      if (this.OneTimePackageList[i].Selected) {
        this.IssueOneTimePackageModel.PaidAmt = this.IssueOneTimePackageModel.PaidAmt + parseFloat(this.OneTimePackageList[i].TotalPrice);
      }
    }

    this.IssueOneTimePackageModel.PaidAmt = this.globalHelper.Decimal(this.IssueOneTimePackageModel.PaidAmt);
  }
  ItemGeneralValidateNow() {
    this.StudentMsg = ''
    if (this.IssueOneTimePackageModel.StudentID == 0) {
      this.StudentMsg = 'Please Select Student';
      return false;
    }
    this.PayMsg = ''
    if (this.GeneralItemModel.PaymentModeID == 0) {
      this.PayMsg = 'Please Select Payment Mode';
      return false;
    }
    return true;
  }
  SavePayNow() {
    if (this.ItemGeneralValidateNow()) {
      this.GeneralItemModel.PaymentStatus = 'Y';
      this.GeneralItemModel.StudentID = this.IssueOneTimePackageModel.StudentID;
      this.GeneralItemModel.SectionID = this.IssueOneTimePackageModel.SectionID;
      this.GeneralItemModel.ClassID = this.IssueOneTimePackageModel.ClassID;
      this.HidePay = true;
      this.spinnerService.show();
      this.bookstoreservice.SaveIssueOneTimePackage(JSON.stringify(this.GeneralItemModel), JSON.stringify(this.AddedItemList)).subscribe((data: any) => {
        this.spinnerService.hide();

        this.GeneralItemReceiptModel.ReceiptNo = data.ReceiptNo;
        this.ReceiptModel.ReceiptNo = data.ReceiptNo;
        this.GetIssuePackageFeeReceipt(data.ReceiptNo);
        this.globalHelper.CheckActionStatus(data);
        this.IssueOneTimePackageDetails();

      });
    }
  };

  GetSellingPrice() {

    for (var i = 0; i < this.GeneralItemList.length; i++) {
      if (this.GeneralItemList[i].ItemId == this.GeneralItemModel.ItemID) {
        this.GeneralItemModel.UnitPrice = this.GeneralItemList[i].SellingPrice;

      }
    }
  }
  GeneralItemClearIssue() {

    this.IssueOneTimePackageModel.ClassID = 0;
    this.IssueOneTimePackageModel.SectionID = 0;
    this.IssueOneTimePackageModel.StudentID = 0;
    this.GeneralItemModel = {
      ItemCategoryID: 0,
      ClassID: 0,
      ItemID: 0,
      ItemName: '',
      Qty: 1,
      UnitPrice: 0,
      Remarks: '',
      AvailableQty: 0,
      PackageID: 0,
      Pay: '',
      PaidAmt: 0,
      BankID: 0,
      ChequeNo: '',
      ChequeDate: '',
      PaymentModeID: 0,
      PaymentStatus: '',
      StudentID: 0,
      SectionID: 0,

    }
    this.AddedItemList = [];
    //this.GeneralItemModel = {};
    //this.Clear();
    this.ReceiptModel.ReceiptNo = '';
    this.GeneralItemReceiptModel.ReceiptNo = '';
    this.IssueOneTimePackageModel.IsOneTimePackage = false;
    this.Submitted = false;
    this.ItemMsg = "";
    this.ItemQty = "";
    this.StudentMsg = '';
    this.PayMsg = '';
    this.HidePay = false;
    this.GeneralItemModel.Pay = '';
  }

  AddValidate() {
    this.ItemMsg = "";
    this.ItemQty = "";
    if (this.IssueOneTimePackageModel.ItemID == 0) {
      this.ItemMsg = 'Please Select Item';
      return false;
    }

    else if (this.IssueOneTimePackageModel.Qty == 0) {
      this.ItemQty = 'Please enter Qty';
      return false;
    }
    else if (this.IssueOneTimePackageModel.AvailableQty < this.IssueOneTimePackageModel.Qty) {
      this.ItemMsg = 'Item is out of stock?';
      return false;
    }
    else {
      for (var i = 0; i < this.ItemList.length; i++) {
        if (this.ItemList[i].ItemID == this.IssueOneTimePackageModel.ItemID) {
          this.ItemMsg = 'Item is already exist';
          return false;
        }

      }
    }
    return true;
  }


  Add() {
    if (this.AddValidate()) {
      var item = {
        ItemName: this.IssueOneTimePackageModel.ItemName,
        ItemID: this.IssueOneTimePackageModel.ItemID,
        Qty: this.IssueOneTimePackageModel.Qty,
        InventoryCategoryID: this.IssueOneTimePackageModel.InventoryCategoryID,
        UnitPrice: this.IssueOneTimePackageModel.UnitPrice,
      };

      this.ItemList.push(item);

      this.SumTotalAmount();
    }
  }

  GetItemDetails() {
    this.IssueOneTimePackageModel.AvailableQty = 0;
    for (var i = 0; i < this.OneTimePackageList.length; i++) {

      if (this.OneTimePackageList[i].ItemID == this.IssueOneTimePackageModel.ItemID) {
        this.IssueOneTimePackageModel.AvailableQty = this.OneTimePackageList[i].AvailableQty
      }
    }
  }


  SumTotalAmount() {
    this.IssueOneTimePackageModel.PaidAmt = 0;
    for (var i = 0; i < this.ItemList.length; i++) {
      this.IssueOneTimePackageModel.PaidAmt = this.IssueOneTimePackageModel.PaidAmt + this.ItemList[i].Qty * this.ItemList[i].UnitPrice;
    }

    this.IssueOneTimePackageModel.PaidAmt = this.globalHelper.Decimal(this.IssueOneTimePackageModel.PaidAmt);
  }

  Validation() {
    this.ItemMsg = "";
    for (var i = 0; i < this.ItemList.length; i++) {
      if (this.IssueOneTimePackageModel.ItemID == this.ItemList[i].ItemID) {
        this.ItemMsg = 'Item Already Exist';
        return false;
      }
      else if (this.IssueOneTimePackageModel.AvailableQty < this.IssueOneTimePackageModel.Qty) {
        this.ItemMsg = 'Item is out of stock?';
        return false;
      }
    }
    return true;
  };

  // Payment

  PackageValidateLater() {
    this.StudentMsg = ''
    if (this.IssueOneTimePackageModel.StudentID == 0) {
      this.StudentMsg = 'Please Select Student';
      return false;
    }
    return true;

  }
  PackageValidateNow() {
    this.StudentMsg = ''
    if (this.IssueOneTimePackageModel.StudentID == 0) {
      this.StudentMsg = 'Please Select Student';
      return false;
    }
    this.PayMsg = ''
    if (this.IssueOneTimePackageModel.PaymentModeID == 0) {
      this.PayMsg = 'Please Select Payment Mode';
      return false;
    }
    return true;
  }

  SavePackageNow() {
    if (this.PackageValidateNow()) {
      this.IssueOneTimePackageModel.PaymentStatus = 'Y';
      if (this.IssueOneTimePackageModel.IsOneTimePackage) {
        this.ItemList.splice(0, this.ItemList.length);
        for (var i = 0; i < this.OneTimePackageList.length; i++) {

          if (this.OneTimePackageList[i].Selected)
            this.ItemList.push(this.OneTimePackageList[i]);
        }
      }

      this.HidePayPack = true;
      this.spinnerService.show();
      this.bookstoreservice.SaveIssueOneTimePackage(JSON.stringify(this.IssueOneTimePackageModel), JSON.stringify(this.ItemList)).subscribe((data: any) => {
        this.spinnerService.hide();
        this.ReceiptModel.ReceiptNo = data.ReceiptNo;
        this.PackageReceiptModel.ReceiptNo = data.ReceiptNo;
        this.GetIssuePackageFeeReceipt(data.ReceiptNo);
        this.globalHelper.CheckActionStatus(data);
        this.IssueOneTimePackageDetails();

      });
    }
  };


  ItemGeneralValidateLater() {
    this.StudentMsg = ''
    if (this.IssueOneTimePackageModel.StudentID == 0) {
      this.StudentMsg = 'Please Select Student';
      return false;
    }
    return true;

  }
  AddedItemValidate() {
    return this.GeneralItemModel.ItemID == 0 || this.GeneralItemModel.ItemCategoryID == 0;
  };
  GetGeneralItem() {
    var itembo = {
      'ItemId': this.GeneralItemModel.ItemCategoryID,
      'ItemId1': 2,
    }
    this.lookupservice.GetLookupsList('ItemMaster', JSON.stringify(itembo)).subscribe((data: any) => {
      this.GeneralItemList = data.LookupItems;
    });
  };
  GetItemName(ItemID) {
    for (var i = 0; i < this.GeneralItemList.length; i++) {
      if (this.GeneralItemList[i].ItemId == ItemID) {
        return this.GeneralItemList[i].ItemName;
      }
    }
  }

  GetItemCtegory(ItemCategoryID) {
    for (var i = 0; i < this.ItemCategoryList.length; i++) {
      if (this.ItemCategoryList[i].ItemId == ItemCategoryID) {
        return this.ItemCategoryList[i].ItemName;
      }
    }
  }
  AddGeneralItem(valid) {

    this.ItemMsg = "";
    this.AlertSave = '';
    this.GeneralItemMsg = '';

    for (var i = 0; i < this.AddedItemList.length; i++) {

      if (this.AddedItemList[i].ItemID == this.GeneralItemModel.ItemID) {
        this.GeneralItemMsg = 'Item is already exist';
        return;
      }
    }

    this.Submitted = true;
    if (valid && !this.AddedItemValidate()) {
      var item = {
        ItemName: this.GetItemName(this.GeneralItemModel.ItemID),
        ItemID: this.GeneralItemModel.ItemID,
        Qty: this.GeneralItemModel.Qty,
        UnitPrice: this.GeneralItemModel.UnitPrice,
        ItemCategory: this.GetItemCtegory(this.GeneralItemModel.ItemCategoryID),
      };
      this.AddedItemList.push(item);
      this.SumTotalGeneralItemAmount();
    }

  }
  SumTotalGeneralItemAmount() {
    this.GeneralItemModel.PaidAmt = 0;
    for (var i = 0; i < this.AddedItemList.length; i++) {
      this.GeneralItemModel.PaidAmt = this.GeneralItemModel.PaidAmt + this.AddedItemList[i].Qty * this.AddedItemList[i].UnitPrice;
    }

    this.GeneralItemModel.PaidAmt = this.globalHelper.Decimal(this.GeneralItemModel.PaidAmt);
  }
  SavePayLater() {
    if (this.ItemGeneralValidateLater()) {
      this.GeneralItemModel.PaymentStatus = 'N';
      this.GeneralItemModel.PaymentModeID = 0;
      this.GeneralItemModel.StudentID = this.IssueOneTimePackageModel.StudentID;
      this.GeneralItemModel.SectionID = this.IssueOneTimePackageModel.SectionID;
      this.GeneralItemModel.ClassID = this.IssueOneTimePackageModel.ClassID;
      this.HidePay = true;
      this.spinnerService.show();
      this.bookstoreservice.SaveIssueOneTimePackage(JSON.stringify(this.GeneralItemModel), JSON.stringify(this.AddedItemList)).subscribe((data: any) => {
        this.spinnerService.hide();
        this.ReceiptModel.ReceiptNo = data.ReceiptNo;
        this.GeneralItemReceiptModel.ReceiptNo = data.ReceiptNo;
        this.GetIssuePackageFeeReceipt(data.ReceiptNo);
        this.globalHelper.CheckActionStatus(data);
        this.IssueOneTimePackageDetails();

      });
    }
  };

  GetIssuePackageFeeReceipt(receiptid) {

    this.bookstoreservice.GetIssuePackageFeeReceipt(receiptid).subscribe((data: any) => {
      this.FeeReceiptItemList = data.FeeReceiptItemList;

    });
  };

  SavePackageLater() {
    if (this.PackageValidateLater()) {
      this.IssueOneTimePackageModel.PaymentStatus = 'N';
      if (this.IssueOneTimePackageModel.IsOneTimePackage) {
        this.ItemList.splice(0, this.ItemList.length);
        for (var i = 0; i < this.OneTimePackageList.length; i++) {

          if (this.OneTimePackageList[i].Selected)
            this.ItemList.push(this.OneTimePackageList[i]);
        }
      }

      this.HidePayPack = true;
      this.spinnerService.show();
      this.bookstoreservice.SaveIssueOneTimePackage(JSON.stringify(this.IssueOneTimePackageModel), JSON.stringify(this.ItemList)).subscribe((data: any) => {
        this.spinnerService.hide();
        this.ReceiptModel.ReceiptNo = data.ReceiptNo;
        this.PackageReceiptModel.ReceiptNo = data.ReceiptNo;
        this.GetIssuePackageFeeReceipt(data.ReceiptNo);
        this.globalHelper.CheckActionStatus(data);
        this.IssueOneTimePackageDetails();

      });
    }
  };

  ClearIssue() {
    this.IssueOneTimePackageModel.ClassID = 0;
    this.IssueOneTimePackageModel.SectionID = 0;
    this.IssueOneTimePackageModel.StudentID = 0;
    this.IssueOneTimePackageModel.PackageID = 0;
    this.ReceiptModel.ReceiptNo = '';
    this.PackageReceiptModel.ReceiptNo = '';
    this.IssueOneTimePackageModel.IsOneTimePackage = false;
    this.ItemList = [];
    this.ItemMsg = "";
    this.ItemQty = "";
    this.StudentMsg = '';
    this.PayMsg = '';
    this.HidePayPack = false;
    this.IssueOneTimePackageModel.Pay = '';
  }
  removeRow(index) {
    this.ItemList.splice(index, 1);
    this.SumTotalAmount();

  };

  GeneralItemremoveRow = function (index) {
    this.AddedItemList.splice(index, 1);
    this.SumTotalGeneralItemAmount();
  };

  ngOnInit() {
    this.GetClass();
    this.GetAllSection();
    this.GetPackage()
    this.GetStudent();
    this.GetAllBank();
    this.GetPaymentMode();
    this.GetAllItem();
    this.GetItemCategory();
  }


  GetClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;

    });
  };

  GetAllSection() {
    this.spinnerService.show();
    this.IssueOneTimePackageModel.SectionID = 0;
    this.IssueOneTimePackageModel.StudentID = 0;
    var ItemBo = {
      'ItemId': this.IssueOneTimePackageModel.ClassID
    }
    this.lookupservice.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
      this.spinnerService.hide();

    });
  };


  GetAllBank() {
    this.lookupservice.GetLookupsList('BankAll', '').subscribe((data: any) => {
      this.BankList = data.LookupItems;
    });
  };

  GetStudent() {
    this.spinnerService.show();
    this.IssueOneTimePackageModel.StudentID = 0;
    var itemBo = {
      'ItemId': this.IssueOneTimePackageModel.ClassID,
      'ItemId2': this.IssueOneTimePackageModel.SectionID
    };
    this.lookupservice.GetLookupsList('Student', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.StudentList = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetPackage() {
    this.spinnerService.show();
    var itemBo = {
      ItemId: this.IssueOneTimePackageModel.ClassID,

    };
    this.lookupservice.GetLookupsList('Package', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.PackageList = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetItemCategory() {
    var item = {
      ItemId: 2
    }
    this.lookupservice.GetLookupsList('StockInventoryItemCategory', JSON.stringify(item)).subscribe((data: any) => {
      this.ItemCategoryList = data.LookupItems;
    });
  };

  GetAllItem() {
    this.spinnerService.show();
    var itemBo = {
      ItemId: this.IssueOneTimePackageModel.ClassID,
      ItemId1: this.IssueOneTimePackageModel.PackageID,
    };

    this.lookupservice.GetLookupsList('ClassOneTimePackageItems', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.ItemMasterList = data.LookupItems;
      this.spinnerService.hide();

    });
  };

  GetPaymentMode() {

    this.lookupservice.GetLookupsList('PaymentMode', '').subscribe((data: any) => {
      this.PaymentModeList = data.LookupItems;


    });
  };


  // Update Payment

  UpdateModel = {
    PaymentStatus: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    ReceiptNo: '',
    PaymentModeID: 0,
    PaidAmt: 0,
    BankID: 0,
    ChequeNo: '',
    ChequeDate: '',
  }
  UpadatePayment(item) {
    this.PayMsgU = ''
    this.UpdateModel = item;

  }

  UpadteValidateNow() {
    this.PayMsgU = ''
    if (this.UpdateModel.PaymentModeID == 0) {
      this.PayMsgU = 'Please Select Payment Mode';
      return false;
    }
    return true;
  }
  UpdateIssuePayment() {
    if (this.UpadteValidateNow()) {
      this.UpdateModel.PaymentStatus = 'Y';
      this.spinnerService.show();
      this.bookstoreservice.UpdateIssuePayment(JSON.stringify(this.UpdateModel)).subscribe((data: any) => {
        this.spinnerService.hide();
        // if (data.webResponse.Status) {
        //     $('#btnClose').click();
        // }
        this.globalHelper.CheckActionStatus(data);
        this.IssueOneTimePackageDetails();

      });
    }
  }

  // Cancel

  CancelModel = {
    ReceiptNo: '',
    CancelRemarks: '',
  }

  GetReceiptNo(item) {
    this.CancelModel.ReceiptNo = item.ReceiptNo;
  }

  CancelIssueOneTimePackage() {
    this.spinnerService.show();
    this.bookstoreservice.CancelIssueOneTimePackage(JSON.stringify(this.CancelModel)).subscribe((data: any) => {
      this.globalHelper.CheckActionStatus(data);
      this.IssueOneTimePackageDetails();
      this.spinnerService.hide();

    });
  }

  // Print

  PrintPages(ReceiptNo, PrintType, CopyType, Cancel) {
    if (Cancel == 'Y') {
      CopyType = 'C';
    }
    var url = "issueitemprint?ReceiptNo=" + ReceiptNo + "&PrintType=" + PrintType + "&CopyType=" + CopyType;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

  }

}
